export const environment = {
  production: true,
  apiUrl: 'https://citadel.sparte.io/graphql',
  stage: 'production',
  local: false,
};
